import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FreightListService } from './cargo-list.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Filter, FilterModel } from 'src/app/core/models/filter';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Utils } from 'src/app/core/resources/utils';
import { Titles } from 'src/app/core/resources/titles';
import { CurrencyPipe } from '@angular/common';
import { Company } from 'src/app/core/interfaces/company';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { EmailFormComponent } from '../email-form/email-form.component';
import { Permission } from 'src/app/core/resources/permission';
import { PaginationList } from 'src/app/core/models/pagination-list';
import moment from 'moment';
import { FreightListService as listTurn } from '../cargo-list-turn/cargo-list-turn.service';
import { ListFilterComponent } from 'src/app/shared/list-filter/list-filter.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { ConventionsComponent } from 'src/app/shared/conventions/conventions.component';
import { BellAlertService } from '../bell-alert/bell-alert.service';
import { CargoService } from 'src/app/core/services/cargo.service';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { TurnMatch } from 'src/app/core/interfaces/turnMatch';
import { Destination } from 'src/app/core/interfaces/destination';
import { SelectableItem } from 'src/app/core/interfaces/selectableItem';
import { ConfirmBellAlertsComponent } from '../confirm-bell-alerts/confirm-bell-alerts.component';
import { TravelExpensesService } from 'src/app/core/services/travel-expenses.service';
import { TravelExpense } from 'src/app/core/interfaces/travel-expense';
import { CARGO_TRAVEL_EXPENSES_LAZY } from './cargo-realtime.config';

@Component({
  selector: 'app-cargo-list',
  templateUrl: './cargo-list.component.html',
  styleUrls: ['./cargo-list.component.scss'],
  providers: [CurrencyPipe]
})

export class CargoListComponent implements OnInit, OnDestroy {

  turns: TurnMatch[] = [];
  //@ViewChild(CargoListFilterComponent, { static: false }) cargoListFilterComponent: CargoListFilterComponent;
  @ViewChild(ListFilterComponent) listFilterComponent: ListFilterComponent;
  @Input() typeList: string;
  @Input() modalMode: boolean = false;
  @Input() modalListFilters: string = '';
  @Input() modalInitialCargos: Cargo[] = [];
  @Input() modalInitialTotal: number = 0;
  @Output() resetFilters: EventEmitter<boolean> = new EventEmitter();
  @Output() navigate: EventEmitter<any> = new EventEmitter();
  paramsFilter = '';
  optionsFilter: FilterModel[] = [];
  filterPayments = '';
  filterAproval = 'Pending approval';
  filterTypePayment = 'balance';
  filterDriver = true;
  filterTypeOfDate = true;
  permission = Permission;
  // filterCharges = false;
  onGetListCargo: any;
  activeSelectItem = false;
  itemsSelecteds: Array<Cargo> = [];
  idsWithoutBill: Array<number> = [];
  unfilteredList: Array<Cargo> = [];
  idsWithBill: Array<number> = [];
  filters: string = '';
  company: Company;
  nitCompany: string = '';
  cargoTabsLoadingRoutes = ["loadingRoutes", "emptyContainers", "urbanRoutes", "lastMileRoutes", "nationalRoutes", 'exportRoutes', 'importRoutes', "internationalRoutes"];
  public paginationList: PaginationList = new PaginationList();
  filteredCargosTurns = {};
  filterByUncared = false;
  servicesTravelExpenses = {};
  public cargoListLoading: boolean = true;
  public totalCargos: number = 0;
  public totalUncaredCargos: number = 0;
  private isLoadingPage: boolean = false;
  private uncaredModalPreviewLoading: boolean = false;
  private backendListRefreshTimer: any;
  private readonly backendListRefreshDelay: number = 700;
  // Memos para devolver REFERENCIAS ESTABLES a los @Input de cargo-item (OnPush).
  // Sin esto, getActiveItemSelected()/getFilteredCargo() devuelven un objeto nuevo en
  // cada CD del padre y marcarían cada fila como "dirty", anulando OnPush.
  private _selectableMemo = new WeakMap<Cargo, { sig: string, value: SelectableItem }>();
  private _filteredCargoMemo = new WeakMap<Cargo, { turnsRef: any, allCreated: boolean, value: { cargoConsecutive: string, matches: TurnMatch[] } }>();
  private _allCreatedCache: { listRef: any, value: boolean } | null = null;
  constructor(
    public service: FreightListService,
    private spinner: NgxSpinnerService,
    public authService: AuthService,
    public permissionRole: PermissionRole,
    public global: Global,
    public utils: Utils,
    public titles: Titles,
    private router: Router,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    public cargoListService: FreightListService,
    private listTurn: listTurn,
    public cargoService: CargoService,
    private cdRef: ChangeDetectorRef,
    private travelExpensesService: TravelExpensesService,
  ) {
    this.company = this.authService && this.authService.getCompany();
    // Sin query string: p. ej. ?transportCompanyId= de la pastilla de empresa de transporte.
    this.typeList = window.location.hash.substring(13).split('?')[0];
    localStorage.removeItem('filterByUncared');
    if (this.typeList === 'scheduledLoads') this.getTurns();
  }

  ngOnInit() {
    this.paginationList.setPageSize(10);
    this.onGetListCargo = this.getListCargo.bind(this);
    this.activeSelectItem = this.utils.enableSelectItemByList(this.typeList);
    sessionStorage.setItem('_lastList', this.typeList.toString());
    localStorage.removeItem('hasOpenEval');
    this.optionsFilter = this.service.getOptionsFilter(this.typeList);
    if (this.modalMode) {
      this.initModalList();
      return;
    }

    if (
      this.typeList === 'loadsInNegotiation' &&
      this.paginationList.getPageKey() === 1 &&
      this.paginationList.getList().length === 0
    ) {
      this.getListCargoNegotiation();
    } else if (
      this.typeList === 'cargoRequestNegotiation' &&
      this.paginationList.getPageKey() === 1 &&
      this.paginationList.getList().length === 0
    ) {
      this.getListCargoRequestNegotiation();
    }
    if (this.typeList === 'loadingRoutes' && !CargoService.clickMadeToStartSounds)
      this.showConfirmBellAlerts();
  }


  async showConfirmBellAlerts() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    await this.dialog.open(ConfirmBellAlertsComponent, dialogConfig).afterClosed().toPromise();
    CargoService.clickMadeToStartSounds = true;
  }

  ngOnDestroy(): void {
    if (this.backendListRefreshTimer) clearTimeout(this.backendListRefreshTimer);
    this.resetPagging();
    this.cdRef.detach();
  }

  getListName() {
    let listName = '';
    switch (this.typeList) {
      case 'loadingRoutes':
        listName = 'Servicios en Ruta';
        break;
      case 'scheduledLoads':
        listName = 'Servicios Programados';
        break;
      case 'loadsInNegotiation':
        listName = 'Servicios en Negociación';
        break;
      case 'loadsFinished':
        listName = 'Servicios Terminados';
        break;
      case 'approvePayments':
        listName = 'Servicios para Aprobación de Pago';
        break;
      case 'rndcFulfillments':
        listName = 'Cumplidos RNDC';
        break;
      case 'paymentAdvanceCargo':
      case 'paymentExtraAdvanceCargo':
      case 'paymentAdditionalCostsCargo':
      case 'paymentBalanceCargo':
        listName = 'Servicios para Pago';
        break;
      case 'charges':
        listName = 'Servicios Pendientes de Cobrar';
        break;
      case 'request':
        listName = 'Solicitudes';
        break;
      case 'cargoRequestNegotiation':
        listName = 'Negociación B2B';
        break;
      case 'expired':
        listName = 'Servicios vencidos';
        break;
      case 'deleted':
        listName = 'Servicios eliminados';
        break;
      case 'withoutPayment':
        listName = 'Servicios sin pagos';
        break;
      case 'travelExpensesChecking':
        listName = 'Viáticos';
        break;

    }
    return listName;
  }

  get loadingNextPage(): boolean {
    return this.isLoadingPage && !this.cargoListLoading && !!this.paginationList.getList().length;
  }

  get totalsHeaderLoading(): boolean {
    return this.cargoListLoading && this.paginationList.getPageKey() === 1 && this.cargoTabsLoadingRoutes.includes(this.typeList);
  }

  private initModalList(): void {
    this.filters = this.modalListFilters || '';
    if (this.modalInitialCargos && this.modalInitialCargos.length) {
      const total = this.modalInitialTotal || this.modalInitialCargos.length;
      this.unfilteredList = this.modalInitialCargos;
      this.paginationList.setList(this.modalInitialCargos);
      this.paginationList.setTotal(total);
      this.totalCargos = total;
      this.cargoListLoading = false;
      if (this.paginationList.hasLoadedTotal() || this.modalInitialCargos.length < this.paginationList.getPageSize())
        this.paginationList.setEnablePagingScroll(false);
      return;
    }
    this.getListCargo(this.filters);
  }

  getListCargoNegotiation() {
    this.cargoListLoading = true;
    this.service.getListCargoNegotiation(this.authService.getUserSession().information.document).subscribe(
      (data: any[]) => {
        this.unfilteredList = data && data.length ? data : [];
        this.paginationList.setList(this.unfilteredList);
        this.cargoListLoading = false;
      },
      (error) => {
        this.unfilteredList = [];
        this.cargoListLoading = false;
      }
    );
  }

  getListCargoRequestNegotiation() {
    this.cargoListLoading = true;
    this.service.getListCargoRequestNegotiation(
      this.company.companyId,
      (this.company.parentCompany && this.company.parentCompany.length ? 'Negotiator' : 'Creator')
    ).subscribe(
      (data: any) => {
        this.unfilteredList = data && data.length ? data : [];
        this.paginationList.setList(this.unfilteredList);
        this.cargoListLoading = false;
      },
      (error) => {
        this.unfilteredList = [];
        this.cargoListLoading = false;
      }
    );
  }

  onScrollDown() {
    if (
      this.paginationList.getEnablePagingScroll() &&
      this.typeList !== 'loadsInNegotiation' &&
      this.typeList !== 'cargoRequestNegotiation' &&
      (((this.service.isPaymentCargo(this.typeList) && this.filters.search('paymentType=true') > 0) || (this.service.isPaymentCargo(this.typeList) &&
        this.filters.search('paid=true') === -1)) || !this.service.isPaymentCargo(this.typeList))
    ) {
      this.paginationList.setPageKey(
        this.paginationList.getPageKey() + 1
      );
      this.getListCargo(this.filters);
    }
  }

  onFilter($event) {
    this.filters = $event;
    this.nitCompany = ""
    let valueNit = $event.split('&').filter((filter) => {
      return (filter.search('nit=') >= 0);
    });
    if (valueNit[0]) {
      this.nitCompany = valueNit[0].split('=')[1];
    }
    this.resetPagging();
    this.getListCargo(this.filters);
  }

  cleanFilters($event) {
    this.resetFilters.emit($event);
  }

  setTypeOfDate($event: boolean) {
    this.filterTypeOfDate = $event;
  }

  refreshActualList() {
    this.resetPagging();
    this.getListCargo(this.filters);
  }

  refreshList($event?) {
    // app-list-filter emite (refreshList) durante su ngAfterViewInit, es decir dentro
    // del ciclo de CD del padre; asignar this.filters de forma síncrona ahí provoca
    // ExpressionChangedAfterItHasBeenCheckedError en [filters] de app-list-operations
    // (antes lo enmascaraba el ngAfterViewChecked->detectChanges que se eliminó por
    // rendimiento). Diferir al siguiente microtask deja a filters estable durante el
    // ciclo actual y lo actualiza en un CD posterior.
    Promise.resolve().then(() => {
      if ($event) this.filters = $event;
      this.refreshActualList();
    });
  }

  refreshCargo($event: { cargo: Cargo, action: 'update' | 'delete' }, index: number) {
    if (this.shouldRefreshFromBackendOnCargoChange()) {
      this.scheduleBackendListRefresh();
      return;
    }

    if ($event.action === 'update') {
      const currentList = [...this.paginationList.getList()];
      currentList[index] = $event.cargo;
      this.paginationList.setList(currentList);
      const unfilteredIndex = this.unfilteredList.findIndex(cargo => cargo && cargo.id === $event.cargo.id);
      if (unfilteredIndex >= 0) this.unfilteredList[unfilteredIndex] = $event.cargo;
    } else this.refreshActualList();
  }

  private shouldRefreshFromBackendOnCargoChange(): boolean {
    return this.cargoTabsLoadingRoutes.includes(this.typeList);
  }

  private scheduleBackendListRefresh(): void {
    if (this.backendListRefreshTimer) clearTimeout(this.backendListRefreshTimer);
    this.backendListRefreshTimer = setTimeout(() => {
      this.backendListRefreshTimer = null;
      this.refreshActualList();
    }, this.backendListRefreshDelay);
  }

  trackByCargo(index: number, cargo: Cargo): string | number {
    return cargo && cargo.id ? cargo.id : cargo && cargo.consecutive ? cargo.consecutive : index;
  }

  setFilterByUncared(value: boolean) {
    if (this.filterByUncared === value) return;
    this.filterByUncared = value;
    localStorage.setItem('filterByUncared', this.filterByUncared.toString());
    this.refreshActualList();
  }

  resetPagging() {
    this.paginationList.setPageKey(1);
    this.unfilteredList = [];
    this.paginationList.setList([]);
    this.paginationList.setTotal(0);
    this.paginationList.setEnablePagingScroll(true);
    this.totalCargos = 0;
    this.totalUncaredCargos = 0;
    this.isLoadingPage = false;
    // Liberar el caché de viáticos por cargo: crece con cada página/filtro y no se
    // limpiaba al resetear (relevante en modo no-lazy).
    this.servicesTravelExpenses = {};
  }

  getListCargo($event) {
    if (this.isLoadingPage) return;
    let service = null;
    this.itemsSelecteds = [];
    if (this.typeList === 'charges' || this.typeList === 'approvePayments')
      $event = $event.replace('&approval=all', '');
    $event = $event.replace('&paymentType=true', '&paid=true');
    $event = $event.replace('&paymentType=advanceState', '');
    if ($event.includes('ministryFulfillment=all'))
      $event = $event.replace('&ministryFulfillment=all', '');
    if (this.cargoTabsLoadingRoutes.includes(this.typeList)) {
      $event = this.getLoadingRoutesBackendFilters($event);
      this.loadUncaredModalPreview($event);
    }

    this.cargoListLoading = this.paginationList.getPageKey() === 1;
    this.isLoadingPage = true;
    service = this.service.getListCargo(
      $event,
      this.paginationList.getPageKey(),
      this.paginationList.getPageSize(),
      this.typeList
    );

    // Cancelar una consulta de lista anterior aún en vuelo para que su respuesta
    // (obsoleta al cambiar de filtro/listado) no contamine la lista actual.
    service.subscribe(
      async (response: any) => {
        let data: Cargo[] = response.results || [];
        const total = response.pagination && this.utils.isDefined(response.pagination.total)
          ? response.pagination.total
          : data.length;
        this.paginationList.setTotal(total);
        this.totalCargos = total;
        // En modo lazy NO se precargan viáticos por item (evita N peticiones HTTP
        // por página); cada cargo-item los carga bajo demanda al abrir el detalle.
        if (!CARGO_TRAVEL_EXPENSES_LAZY && data && data.length) {
          data = await Promise.all(data.map(async (item: Cargo) => {
            if (![CargoStateEnum.CREATED, CargoStateEnum.ACCEPTED, CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE].includes(item.state)
              || !this.utils.isTransportService(item))
              item.travelExpenses = [];
            else {
              if (!this.servicesTravelExpenses[item.id])
                this.servicesTravelExpenses[item.id] = await this.getTravelExpensesByCargo(item.id);
              item.travelExpenses = this.servicesTravelExpenses[item.id];
            }
            return item;
          }));
        }
        if (!this.utils.isDefined(data) || data.length === 0) {
          this.paginationList.setEnablePagingScroll(false);
          data = [];
        }

        if (this.paginationList.getList().length && this.paginationList.getPageKey() > 1) {
          this.unfilteredList = this.unfilteredList.concat(data);
        }
        else this.unfilteredList = data;

        if (this.cargoTabsLoadingRoutes.includes(this.typeList)) {
          this.paginationList.setList(this.unfilteredList);
          if (!this.modalMode && this.filterByUncared) {
            this.totalUncaredCargos = total;
          }
          if (!this.modalMode) this.showManifestErrorModalPreview($event);
        } else {
          if (this.typeList === 'scheduledLoads') this.sortTurnCargo();
          this.paginationList.setList(this.unfilteredList);
        }
        if (this.paginationList.hasLoadedTotal() || data.length < this.paginationList.getPageSize())
          this.paginationList.setEnablePagingScroll(false);
        this.cargoListLoading = false;
        this.isLoadingPage = false;
      },
      (error) => {
        this.cargoListLoading = false;
        this.isLoadingPage = false;
        if (!(this.paginationList.getList().length > 0))
          this.resetPagging();
      }
    );
  }

  private getLoadingRoutesBackendFilters(filters: string): string {
    const params = new URLSearchParams((filters || '').replace(/^[&?]/, ''));

    const orderBy = params.get('orderBy');
    if (orderBy) {
      if (orderBy === 'oldFirst') params.set('orderByLastPointLocationDate', 'ASCENDING');
      if (orderBy === 'recentFirst') params.set('orderByLastPointLocationDate', 'DESCENDING');
      params.delete('orderBy');
    }

    const lastPointExistance = params.get('lastPointExistance');
    if (lastPointExistance) {
      params.set('hasLastPointLocationDate', lastPointExistance);
      params.delete('lastPointExistance');
    }

    const lastPointLapse = params.get('lastPointLapse');
    if (lastPointLapse) {
      params.set('lastPointLocationHoursFilter', lastPointLapse);
      params.delete('lastPointLapse');
    }

    const containerExpirationLapse = params.get('containerExpirationLapse');
    if (containerExpirationLapse) {
      params.set('containerExpirationDaysFilter', containerExpirationLapse);
      params.delete('containerExpirationLapse');
    }

    const errorManifest = params.get('errorManifest');
    if (errorManifest === 'true') {
      params.set('hasMinistryError', 'true');
      params.set('manifestAuthorizationNull', 'true');
    }
    params.delete('errorManifest');

    if (this.filterByUncared || params.get('uncared') === 'true') params.set('uncared', 'true');
    else params.delete('uncared');

    const translatedFilters = params.toString();
    return translatedFilters ? `&${translatedFilters}` : '';
  }

  private loadUncaredModalPreview(filters: string): void {
    if (!this.shouldLoadUncaredModalPreview(filters)) return;
    // Marca la sección como ya chequeada de forma síncrona: aunque el preview
    // devuelva 0 resultados (no deja `uncares` poblado) o falle, no debe volver a
    // lanzarse al cambiar de tab/filtro dentro de la misma entrada a la sección.
    BellAlertService.previewChecked = true;
    this.uncaredModalPreviewLoading = true;
    const uncaredFilters = this.getUncaredPreviewFilters(filters);

    this.service.getListCargo(
      uncaredFilters,
      1,
      this.paginationList.getPageSize(),
      this.typeList
    ).subscribe(
      (response: any) => {
        const cargos: Cargo[] = response && response.results ? response.results : [];
        const total = response && response.pagination && this.utils.isDefined(response.pagination.total)
          ? response.pagination.total
          : cargos.length;
        this.uncaredModalPreviewLoading = false;
        if (this.shouldOpenUncaredModal(cargos)) BellAlertService.stack(cargos, uncaredFilters, total);
      },
      () => {
        this.uncaredModalPreviewLoading = false;
      }
    );
  }

  private getUncaredPreviewFilters(filters: string): string {
    const params = new URLSearchParams((filters || '').replace(/^[&?]/, ''));
    params.set('uncared', 'true');

    const previewFilters = params.toString();
    return previewFilters ? `&${previewFilters}` : '';
  }

  private shouldLoadUncaredModalPreview(filters: string): boolean {
    return this.paginationList.getPageKey() === 1
      && !this.modalMode
      && !this.filterByUncared
      && !this.uncaredModalPreviewLoading
      && !BellAlertService.previewChecked
      && !BellAlertService.uncares.length
      && this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.registerLocation)
      && !this.hasUncaredFilter(filters)
      && !this.hasLastPointLocationDateFalseFilter(filters);
  }

  private shouldOpenUncaredModal(cargos: Cargo[]): boolean {
    return cargos.length > 0
      && !BellAlertService.uncares.length;
  }

  private hasUncaredFilter(filters: string): boolean {
    const params = new URLSearchParams((filters || '').replace(/^[&?]/, ''));
    return params.get('uncared') === 'true';
  }

  private hasLastPointLocationDateFalseFilter(filters: string): boolean {
    const params = new URLSearchParams((filters || '').replace(/^[&?]/, ''));
    return params.get('hasLastPointLocationDate') === 'false'
      || params.get('lastPointExistance') === 'false';
  }

  private showManifestErrorModalPreview(filters: string): void {
    if (!this.shouldLoadManifestErrorModalPreview(filters)) return;
    // Mismo gate por-entrada que el preview de sin atender (mutuamente excluyentes
    // por permiso): no relanzar en cada tab/filtro dentro de la misma sección.
    BellAlertService.previewChecked = true;

    this.service.getListCargo(
      this.getManifestErrorModalPreviewFilters(filters),
      1,
      this.paginationList.getPageSize(),
      this.typeList
    ).subscribe(
      (response: any) => {
        const cargos: Cargo[] = response && response.results ? response.results : [];
        const total = response && response.pagination && this.utils.isDefined(response.pagination.total)
          ? response.pagination.total
          : cargos.length;
        if (cargos.length && !CargoService.uncares.length)
          CargoService.stack(cargos, this.getManifestErrorModalPreviewFilters(filters), total);
      },
      () => { }
    );
  }

  private shouldLoadManifestErrorModalPreview(filters: string): boolean {
    return this.paginationList.getPageKey() === 1
      && !BellAlertService.previewChecked
      && !CargoService.uncares.length
      && this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.showManifestError)
      && !this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.registerLocation)
      && !this.hasManifestErrorFilter(filters);
  }

  private hasManifestErrorFilter(filters: string): boolean {
    const params = new URLSearchParams((filters || '').replace(/^[&?]/, ''));
    return params.get('errorManifest') === 'true'
      || (params.get('hasMinistryError') === 'true' && params.get('manifestAuthorizationNull') === 'true');
  }

  private getManifestErrorModalPreviewFilters(filters: string): string {
    const params = new URLSearchParams((filters || '').replace(/^[&?]/, ''));
    params.delete('errorManifest');
    params.set('hasMinistryError', 'true');
    params.set('manifestAuthorizationNull', 'true');

    const previewFilters = params.toString();
    return previewFilters ? `&${previewFilters}` : '';
  }

  private async getTravelExpensesByCargo(CargoId: string): Promise<Array<TravelExpense>> {
    try {
      const expenses = await this.travelExpensesService.byCargoId(CargoId).toPromise();
      return expenses && expenses.length ? expenses : [];
    } catch (error) {
      return [];
    }
  }

  onSelectItem($event) {
    this.itemsSelecteds = $event;
  }

  sortTurnCargo() {
    this.filteredCargosTurns = {};
    this.turns.forEach(turn => {
      if (this.filteredCargosTurns[turn.origin.id]) {
        if (this.filteredCargosTurns[turn.origin.id][turn.vehicleType]) {
          this.filteredCargosTurns[turn.origin.id][turn.vehicleType].push(turn)
        } else {
          this.filteredCargosTurns[turn.origin.id][turn.vehicleType] = [];
          this.filteredCargosTurns[turn.origin.id][turn.vehicleType].push(turn);
        }

      } else {
        this.filteredCargosTurns[turn.origin.id] = [];
        this.filteredCargosTurns[turn.origin.id][turn.vehicleType] = [];
        this.filteredCargosTurns[turn.origin.id][turn.vehicleType].push(turn);
      }
    })
  }

  /**
   * Gate de "todos los cargos del listado están en estado CREATED", cacheado por
   * referencia de la lista (getList() devuelve la misma referencia hasta setList()),
   * para no recorrer la lista en cada llamada a getFilteredCargo() por fila.
   */
  private get allCargosCreated(): boolean {
    const list = this.paginationList.getList();
    if (this._allCreatedCache && this._allCreatedCache.listRef === list) return this._allCreatedCache.value;
    const value = list.every(cargo => cargo.state === CargoStateEnum.CREATED);
    this._allCreatedCache = { listRef: list, value };
    return value;
  }

  getFilteredCargo(consecutive: string, vehicleType: string, origin: string, dateLoad: string, cargo: Cargo) {
    if (!cargo) return { cargoConsecutive: consecutive, matches: [] };
    const turnsRef = this.filteredCargosTurns;
    const allCreated = this.allCargosCreated;
    const cached = this._filteredCargoMemo.get(cargo);
    // Referencia estable mientras no cambien la lista (allCreated) ni los turnos
    // (filteredCargosTurns se reasigna a un objeto nuevo al reconstruirse).
    if (cached && cached.turnsRef === turnsRef && cached.allCreated === allCreated) return cached.value;
    const value = this.computeFilteredCargo(consecutive, vehicleType, origin, dateLoad, cargo, allCreated);
    this._filteredCargoMemo.set(cargo, { turnsRef, allCreated, value });
    return value;
  }

  private computeFilteredCargo(consecutive: string, vehicleType: string, origin: string, dateLoad: string, cargo: Cargo, allCreated: boolean) {
    if (allCreated) {
      let matches = [];
      let dateLoadFormatted = moment(dateLoad).utc().format('YYYY-MM-DD ZZ');
      const destinations: Destination[] = this.utils.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
      let destinationCities = destinations && destinations.length ? destinations : [];
      if (this.filteredCargosTurns && this.filteredCargosTurns[origin] && this.filteredCargosTurns[origin][vehicleType])
        matches = this.filteredCargosTurns[origin][vehicleType].filter((turn: TurnMatch) =>
          this.validDates(dateLoadFormatted, turn.date) &&
          (!destinationCities.length || !turn.destination || destinationCities.some(city =>
            turn.destination.id === city.municipalityCode || turn.destination.name === city.name
          ))
        );
      return { cargoConsecutive: consecutive, matches: matches };
    }
    return { cargoConsecutive: consecutive, matches: [] };
  }

  validDates(originDateLoad, turnDate) {
    switch (originDateLoad) {
      case moment(turnDate, 'YYYY-MM-DD ZZ').utc().format('YYYY-MM-DD ZZ'):
      case moment(turnDate, 'YYYY-MM-DD ZZ').add(1, 'days').utc().format('YYYY-MM-DD ZZ'):
      case moment(turnDate, 'YYYY-MM-DD ZZ').add(2, 'days').utc().format('YYYY-MM-DD ZZ'):
        return true;
      default:
        return false;
    }
  }

  isSelectableFunction = (item: Cargo) => {
    const isSelectable = this.getActiveItemSelected(item);
    return isSelectable.isSelectable && isSelectable.isEnabled;
  }

  getActiveItemSelected(cargo: Cargo): SelectableItem {
    if (!cargo) return { isSelectable: false };
    // Referencia estable por (cargo, activeSelectItem, typeList, filters). El resultado
    // solo depende de eso; al cambiar de filtro/listado la firma cambia y se recalcula.
    const sig = `${this.activeSelectItem ? 1 : 0}|${this.typeList}|${this.filters}`;
    const cached = this._selectableMemo.get(cargo);
    if (cached && cached.sig === sig) return cached.value;
    const value = this.computeActiveItemSelected(cargo);
    this._selectableMemo.set(cargo, { sig, value });
    return value;
  }

  private computeActiveItemSelected(cargo: Cargo): SelectableItem {
    if (!this.activeSelectItem) return { isSelectable: false };
    //Facturación
    if (this.isCargoToCharge()) {
      if (this.cargoListService.canBill(this.typeList, this.filters).isSelectable)
        return this.cargoListService.isCargoToBill(cargo, this.typeList, this.filters);
      return { isSelectable: true, isEnabled: true };
    }
    //Aprobación o rechazo de servicios
    if (this.cargoListService.isCargoToApproveOrDisapprove(this.typeList).isSelectable) {
      const isApproval = this.filters.includes('approval=Rejected');
      const isRejection = this.filters.includes('approval=Approved');
      if (isApproval) return this.cargoListService.isCargoToApprove(cargo, this.typeList);
      if (isRejection) return this.cargoListService.isCargoToDisapprove(cargo, this.typeList);
      return { isSelectable: true, isEnabled: true };
    }
    //Cumplir servicios RNDC
    if (this.cargoListService.canFulfillRndc(this.typeList, this.filters).isSelectable)
      return this.cargoListService.isCargoToRndcFulfill(this.typeList, cargo, this.filters);
    if (this.cargoListService.canGenerateJournal(this.typeList).isSelectable)
      return this.cargoListService.isCargoToGenerateJournal(cargo, this.typeList);
    return { isSelectable: false }
  }

  isCargoToCharge(): boolean {
    return this.typeList === 'charges';
  }

  get showSelectAll() {
    if (this.modalMode) return false;
    return (this.activeSelectItem && (this.isCargoToCharge() || this.cargoListService.isCargoToApproveOrDisapprove(this.typeList).isSelectable)
      || this.cargoListService.canFulfillRndc(this.typeList, this.filters).isSelectable);
  }

  navigateTo(url: string) {
    this.router.navigate([url])

  }

  public showDialog($event?: Company) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.data = {
      nit: $event.companyId
    }
    const dialoRef = this.dialog.open(EmailFormComponent, dialogConfig);
    dialoRef.afterClosed().subscribe(result => {
      if (result && result.state) {
        if (result.value && result.value.length) {
          this.spinner.show();
          this.cargoListService.sendReport($event.companyId, result.value).subscribe(
            (success) => {
              this.authService.getAllCompanies().subscribe((success) => {
                this.spinner.hide();
                this.snackBarService.openSnackBar('Reporte enviado correctamente');
              }, () => {
                this.spinner.hide();
                this.snackBarService.openSnackBar('Reporte enviado correctamente');
              });
              // this.utils.downloadFile(success, 'Reporte', 'application/xls');
            }, (error) => {
              this.spinner.hide();
              this.snackBarService.openSnackBar('Ocurrió un error al enviar reporte', undefined, 'error');
            });
        }
      };
    })
  }

  getTurns() {
    let filterData = '';
    let currentDateFormatted = moment().subtract(2, 'days').format('YYYY-MM-DD ZZ');
    filterData += '&date=' + currentDateFormatted;
    // filterData += '&state=Available'
    const turnObserver = {
      next: (data) => {
        this.spinner.hide();
        if (data && data.length) this.turns = data.filter(turn => turn.state && turn.state !== 'Deleted');
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar("No se ha podido enviar la información", undefined, 'error');
      },
      complete: () => {
        this.spinner.hide();
      }
    };
    this.spinner.show();
    this.listTurn.getListTurn(filterData).subscribe(turnObserver);
  }

  get showConventionsPayment(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.paymentSemaphore) || this.optionsFilter.some(option => [Filter.showFilterAprovedCargo, Filter.showFilterMinistryFulfillment].includes(option.filterName));
  }
  get showConventionsTransportedValue(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.transportedValueSemaphore)
      && !this.optionsFilter.some(option => [Filter.showFilterAprovedCargo].includes(option.filterName));
  }
  get showFilterTracking(): boolean {
    return this.cargoTabsLoadingRoutes.includes(this.typeList);
  }
  get showConventionsSelectItems(): boolean {
    return this.showSelectAll;
  }
  get showConventionsPausedCargos(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.cargosInRoute) && this.cargoTabsLoadingRoutes.includes(this.typeList);
  }
  get showFilterManifestError(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.showManifestError);
  }

  openConventions() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {};
    if (this.optionsFilter.some(option => [Filter.showFilterAprovedCargo, Filter.showFilterMinistryFulfillment].includes(option.filterName))) dialogConfig.data['payment'] = true;
    else if (this.showConventionsTransportedValue) dialogConfig.data['transported'] = true;
    else if (this.showConventionsPayment) dialogConfig.data['payment'] = true;
    if (this.showFilterTracking) dialogConfig.data['tracking'] = true;
    if (this.showConventionsSelectItems) dialogConfig.data['select'] = true;
    if (this.showConventionsPausedCargos) dialogConfig.data['paused'] = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.dialog.open(ConventionsComponent, dialogConfig);
  }

  get hasOperationsInline(): boolean {//Inline into tab
    let types = ["withoutPayment"];
    return types.includes(this.typeList);
  }
  get hasOperationsInlineLeft(): boolean {
    if (this.modalMode) return false;
    return this.cargoTabsLoadingRoutes.includes(this.typeList);
  }
  get hasOperationsTop(): boolean {
    let typesWithoutPermissions = ["approvePayments", "rndcFulfillments"];
    let chargesPermissionXML: boolean = this.typeList === "charges" && !this.permissionRole.hasPermission(
      this.permission.payments.module, this.permission.payments.billingXML);
    return typesWithoutPermissions.includes(this.typeList) || chargesPermissionXML;
  }
  get hasOperationsTopExtra(): boolean {
    let chargesPermissionXML: boolean = this.typeList === "charges" && this.permissionRole.hasPermission(
      this.permission.payments.module, this.permission.payments.billingXML);
    return chargesPermissionXML;
  }
  get hasOperations(): boolean {
    return this.hasOperationsInline || this.hasOperationsInlineLeft || this.hasOperationsTop || this.hasOperationsTopExtra;
  }

}
